/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Capitallabel2Inputs */

const ja_company_companydetails_capitallabel2 = /** @type {(inputs: Company_Companydetails_Capitallabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資本金`)
};

const en_company_companydetails_capitallabel2 = /** @type {(inputs: Company_Companydetails_Capitallabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capital`)
};

/**
* | output |
* | --- |
* | "Capital" |
*
* @param {Company_Companydetails_Capitallabel2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_capitallabel2 = /** @type {((inputs?: Company_Companydetails_Capitallabel2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Capitallabel2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_capitallabel2(inputs)
	return en_company_companydetails_capitallabel2(inputs)
});
export { company_companydetails_capitallabel2 as "company_companyDetails_capitalLabel" }